import { useEffect, useState } from "react";
import { NumInput } from "./NumberInput";
import {
  addBrand,
  recalc,
  recalcLab,
  recalcBar,
  recalcGinni,
  recalcCoin,
  recalcSilver,
} from "./helperFunctions";
import { useBrands } from "../../../context/BrandsContext";

export function PCForm({
  tx,
  brands,
  isEdit,
  onSave,
  onCancel,
  refreshBrands,
  isGiven,
}) {
  const [form, setForm] = useState({ ...tx });
  const [loadingBrand, setLoadingBrand] = useState(false);

  const weightId = isGiven ? "givenWeightTypeInput" : "weightTypeInput";
  const kp = isGiven ? "givenPc" : "pc";

  const set = (key) => (val) => setForm((p) => recalc({ ...p, [key]: val }));

  const handleBrandChange = (val) => {
    if (val === "add-new") setForm((p) => ({ ...p, showNewBrand: true }));
    else setForm((p) => ({ ...p, brand: val, showNewBrand: false }));
  };

  const cancelBrand = () =>
    setForm((p) => ({ ...p, showNewBrand: false, newBrandInput: "" }));

  return (
    <>
      {isEdit && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 6,
          }}
        >
          <span style={{ fontSize: 12, fontWeight: 700, color: "#ffb703" }}>
            Editing transaction
          </span>
          <button
            onClick={onCancel}
            style={{
              fontSize: 11,
              padding: "3px 10px",
              background: "#575656",
              border: "1px solid #ffb703",
              borderRadius: 4,
              cursor: "pointer",
              color: "#ffb703",
            }}
          >
            Cancel
          </button>
        </div>
      )}

      <div className="section">
        <label>Brand</label>
        {!form.showNewBrand && (
          <select
            className="Brand-selt"
            id={isGiven ? "brandSelt" : "brandSelect"}
            value={form.brand}
            onChange={(e) => handleBrandChange(e.target.value)}
          >
            <option value="Select">Select</option>
            {brands.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
            <option value="add-new">+ Add New Brand</option>
          </select>
        )}
        {form.showNewBrand && (
          <div
            id={isGiven ? "newBrandSeltInput" : "newBrandInput"}
            style={{ display: "block", marginTop: 10 }}
          >
            <input
              type="text"
              id={isGiven ? "brandNameSeltInput" : "brandNameInput"}
              value={form.newBrandInput}
              placeholder="Enter new brand"
              onChange={(e) =>
                setForm((p) => ({ ...p, newBrandInput: e.target.value }))
              }
              style={{
                padding: "8px 12px",
                width: "100%",
                border: "2px solid #777",
                borderRadius: 6,
                fontSize: 14,
                outline: "none",
                transition: "border-color 0.3s",
                marginBottom: 8,
                boxSizing: "border-box",
                background: "#575656",
                color: "#fff",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#ffb703")}
              onBlur={(e) => (e.target.style.borderColor = "#777")}
            />
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() =>
                  addBrand(setLoadingBrand, form, setForm, refreshBrands, "pc")
                }
                disabled={loadingBrand}
                style={{
                  padding: "8px 16px",
                  flex: 1,
                  background: "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
                  color: "white",
                  border: "none",
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                {loadingBrand ? "Loading..." : "Add"}
              </button>
              <button
                onClick={cancelBrand}
                style={{
                  padding: "8px 16px",
                  flex: 1,
                  background: "#575656",
                  color: "#fff",
                  border: "2px solid #777",
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        <label>Qty</label>
        <NumInput
          id={`${kp}PcQtyInput`}
          value={form.qty}
          onChange={set("qty")}
          step="1"
          min={0}
        />
        <label>Diff</label>
        <NumInput
          id={`${kp}DiffInput`}
          value={form.diff}
          onChange={set("diff")}
        />
      </div>

      <div className="section">
        <label>Diff Amount</label>
        <NumInput
          id={`${kp}DiffAmountInput`}
          value={form.totalAmount}
          onChange={set("totalAmount")}
        />
        <label>Weight</label>
        <NumInput
          id={weightId}
          value={form.weight}
          onChange={set("weight")}
          placeholder="116.640 g"
          style={{
            padding: "6px 10px",
            border: "2px solid #ddd",
            borderRadius: 4,
            fontSize: 14,
            outline: "none",
            width: "100%",
          }}
        />
        <label>Total Weight</label>
        <NumInput
          id={`${kp}PcTotalWeightInput`}
          value={form.totalWeight}
          readOnly
        />
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <button
          onClick={() => onSave(form)}
          style={{
            flex: 1,
            padding: "8px 16px",
            background: "linear-gradient(135deg,#ffb703 0%,#a87506 100%)",
            color: "#1a0a00",
            border: "none",
            borderRadius: 5,
            fontSize: 14,
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {isEdit ? "Update" : "Save Transaction"}
        </button>
        {!isEdit && onCancel && (
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              background: "#575656",
              color: "#fff",
              border: "1px solid #777",
              borderRadius: 5,
              fontSize: 14,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </>
  );
}

export function LabForm({
  tx,
  isEdit,
  onSave,
  onCancel,
  isGiven,
  handleReportSubmit,
}) {
  const [form, setForm] = useState({ ...tx });

  const kp = isGiven ? "givenLab" : "receiveLab";
  const set = (key) => (val) => setForm((p) => recalcLab({ ...p, [key]: val }));

  return (
    <>
      {isEdit && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 6,
          }}
        >
          <span style={{ fontSize: 12, fontWeight: 700, color: "#ffb703" }}>
            Editing transaction
          </span>
          <button
            onClick={onCancel}
            style={{
              fontSize: 11,
              padding: "3px 10px",
              background: "#575656",
              border: "1px solid #ffb703",
              borderRadius: 4,
              cursor: "pointer",
              color: "#ffb703",
            }}
          >
            Cancel
          </button>
        </div>
      )}

      <div className="section">
        <label>Report</label>
        <NumInput
          id={`${kp}ReportInput`}
          value={form.report}
          onChange={set("report")}
        />
        <label>Weight</label>
        <NumInput
          id={`${kp}WeightInput`}
          value={form.weight}
          onChange={set("weight")}
        />
        <label>Pure Weight</label>
        <NumInput
          id={`${kp}PureWeightInput`}
          value={form.pureWeight}
          readOnly
        />
      </div>

      <div className="section">
        <label>Diff</label>
        <NumInput
          id={`${kp}DiffInput`}
          value={form.diff}
          onChange={set("diff")}
        />
        <label>Diff Amount</label>
        <NumInput
          id={`${kp}DiffAmountInput`}
          value={form.diffAmount}
          readOnly
        />
      </div>

      <div className="section">
        <label id="sec-1">Total Amount</label>
        <NumInput
          id={`${kp}TotalAmountInput`}
          value={form.totalAmount}
          readOnly
        />
      </div>

      <div className="section">
        <label>Testing Fees (P W)</label>
        <NumInput
          id={`${kp}TestingPwInput`}
          value={form.testingPw}
          onChange={set("testingPw")}
        />
        <label>Testing Fees (O A)</label>
        <NumInput
          id={`${kp}TestingOaInput`}
          value={form.testingOa}
          onChange={set("testingOa")}
        />
        <label>Qty</label>
        <NumInput
          id={`${kp}TestingOaQtyInput`}
          value={form.testingOaQty}
          onChange={set("testingOaQty")}
          step="1"
          min={0}
        />
      </div>

      {/* View Report + WhatsApp checkbox — only shown when editing or as new entry */}
      {handleReportSubmit && (
        <div className="section">
          <button
            type="button"
            className="btn btn-warning px-3"
            onClick={() => handleReportSubmit(form)}
          >
            View Report
          </button>
        </div>
      )}
      <div
        className="d-flex align-items-center gap-2 mb-3"
        style={{ marginTop: -6, cursor: "pointer" }}
      >
        <input
          className="form-check-input m-0"
          style={{ cursor: "pointer", width: 15, height: 15 }}
          type="checkbox"
          id={`${kp}ResendReport`}
          checked={!!form.resendReport}
          onChange={(e) =>
            setForm((p) => ({ ...p, resendReport: e.target.checked }))
          }
        />
        <label
          className="fs-6 m-0"
          htmlFor={`${kp}ResendReport`}
          style={{ cursor: "pointer", userSelect: "none", lineHeight: 1 }}
        >
          Send Report via WhatsApp
        </label>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <button
          onClick={() => onSave(form)}
          style={{
            flex: 1,
            padding: "8px 16px",
            background: "linear-gradient(135deg,#ffb703 0%,#a87506 100%)",
            color: "#1a0a00",
            border: "none",
            borderRadius: 5,
            fontSize: 14,
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {isEdit ? "Update" : "Save Transaction"}
        </button>
        {!isEdit && onCancel && (
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              background: "#575656",
              color: "#fff",
              border: "1px solid #777",
              borderRadius: 5,
              fontSize: 14,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </>
  );
}

export function BarForm({
  tx,
  isEdit,
  onSave,
  onCancel,
  isGiven,
  brands,
  refreshBrands,
}) {
  const [form, setForm] = useState({ ...tx });
  const [loadingBrand, setLoadingBrand] = useState(false);
  const [brandWeights, setBrandWeights] = useState([]);
  const { brands: storedBrands } = useBrands();

  const kp = isGiven ? "givenBar" : "receiveBar";
  const set = (key) => (val) => {
    setForm((p) => {
      const newState = { ...p, [key]: val };
      if (key === "making") newState._makingModified = true;
      if (key === "weight") newState._makingModified = false;
      return recalcBar(newState, isGiven);
    });
  };

  const handleBrandChange = (val) => {
    if (val === "add-new") setForm((p) => ({ ...p, showNewBrand: true }));
    else setForm((p) => ({ ...p, brand: val, showNewBrand: false }));
  };

  const cancelBrand = () =>
    setForm((p) => ({ ...p, showNewBrand: false, newBrandInput: "" }));

  useEffect(() => {
    if (!form.brand || form.brand?.toLowerCase() === "select") {
      setBrandWeights([]);
      return;
    }

    if (!storedBrands || !Array.isArray(storedBrands)) {
      return;
    }

    const barSection = storedBrands.find(
      (brand) => brand.section?.toLowerCase() === "bar",
    );

    const barBrands = barSection?.brands;

    if (!Array.isArray(barBrands)) {
      setBrandWeights([]);
      return;
    }

    const brandData = barBrands.find(
      (brand) => brand.name?.toLowerCase() === form.brand.toLowerCase(),
    );

    if (!brandData) {
      setBrandWeights([]);
      return;
    }

    setBrandWeights(Array.isArray(brandData.weights) ? brandData.weights : []);
  }, [form.brand, storedBrands]);

  // useEffect(() => {
  //   if (!form.brand || !form.weight || !brandWeights.length) {
  //     return;
  //   }

  //   const selectedWeight = brandWeights.find(
  //     (item) => Number(item.weight) === Number(form.weight),
  //   );

  //   if (!selectedWeight) {
  //     return;
  //   }

  //   const making =
  //     selectedWeight.making !== undefined && selectedWeight.making !== null
  //       ? selectedWeight.making
  //       : "";

  //   setForm((prev) => {
  //     const newState = {
  //       ...prev,
  //       making,
  //       _makingModified: false,
  //     };

  //     return recalcBar(newState, isGiven);
  //   });
  // }, [form.weight, brandWeights]);

  useEffect(() => {
    if (!form.brand || !form.weight) {
      setForm((prev) =>
        recalcBar(
          {
            ...prev,
            making: "",
            _makingModified: false,
          },
          isGiven,
        ),
      );
      return;
    }

    const selectedWeight = brandWeights.find(
      (item) => Number(item.weight) === Number(form.weight),
    );

    // Weight is not configured for this brand
    if (!selectedWeight) {
      setForm((prev) =>
        recalcBar(
          {
            ...prev,
            making: "",
            _makingModified: false,
          },
          isGiven,
        ),
      );
      return;
    }

    // Weight exists, but making may not be configured
    const making =
      selectedWeight.making !== undefined && selectedWeight.making !== null
        ? selectedWeight.making
        : "";

    setForm((prev) =>
      recalcBar(
        {
          ...prev,
          making,
          _makingModified: false,
        },
        isGiven,
      ),
    );
  }, [form.weight, brandWeights]);

  return (
    <>
      {isEdit && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 6,
          }}
        >
          <span style={{ fontSize: 12, fontWeight: 700, color: "#ffb703" }}>
            Editing transaction
          </span>
          <button
            onClick={onCancel}
            style={{
              fontSize: 11,
              padding: "3px 10px",
              background: "#575656",
              border: "1px solid #ffb703",
              borderRadius: 4,
              cursor: "pointer",
              color: "#ffb703",
            }}
          >
            Cancel
          </button>
        </div>
      )}
      <div className="section">
        <label>Bar Brand</label>
        {!form.showNewBrand && (
          <select
            className="Brand-selt"
            id={isGiven ? "brandSelt" : "brandSelect"}
            value={form.brand}
            onChange={(e) => handleBrandChange(e.target.value)}
          >
            <option value="Select">Select</option>
            {brands.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
            <option value="add-new">+ Add New Brand</option>
          </select>
        )}

        {form.showNewBrand && (
          <div
            id={isGiven ? "newBrandSeltInput" : "newBrandInput"}
            style={{ display: "block", marginTop: 10 }}
          >
            <input
              type="text"
              id={isGiven ? "brandNameSeltInput" : "brandNameInput"}
              value={form.newBrandInput}
              placeholder="Enter new brand"
              onChange={(e) =>
                setForm((p) => ({ ...p, newBrandInput: e.target.value }))
              }
              style={{
                padding: "8px 12px",
                gap: 5,
                width: "100%",
                border: "2px solid #ddd",
                borderRadius: 6,
                fontSize: 14,
                outline: "none",
                transition: "border-color 0.3s",
                marginBottom: 8,
                boxSizing: "border-box",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#667eea")}
              onBlur={(e) => (e.target.style.borderColor = "#ddd")}
            />
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() =>
                  addBrand(setLoadingBrand, form, setForm, refreshBrands, "bar")
                }
                style={{
                  padding: "8px 16px",
                  flex: 1,
                  background: "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
                  color: "white",
                  border: "none",
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                disabled={loadingBrand}
              >
                {loadingBrand ? "Loading..." : "Add"}
              </button>
              <button
                onClick={cancelBrand}
                style={{
                  padding: "8px 16px",
                  flex: 1,
                  background: "#f1f3f5",
                  color: "#495057",
                  border: "2px solid #dee2e6",
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        {/* <label>Bar Brand</label>
        <select
          id={`${kp}BrandSelect`}
          value={state.brand}
          onChange={(e) => set("brand")(e.target.value)}
        >
          <option value="MILLAT">MILLAT</option>
          <option value="KW">KW</option>
          <option value="KBE">KBE</option>
          <option value="Other">Other</option>
          <option value="add-new">+ Add New Brand</option>
        </select>
         */}
        <label>Bar Weight</label>
        <NumInput
          id={`${kp}WeightInput`}
          value={form.weight}
          onChange={set("weight")}
          step="0.001"
          list="barWeightOptions"
        />
        <datalist id="barWeightOptions">
          {brandWeights.map((item, index) => (
            <option key={`${item.weight}-${index}`} value={item.weight} />
          ))}
        </datalist>

        <label>Qnty</label>
        <NumInput
          id={`${kp}QtyInput`}
          value={form.qty}
          onChange={set("qty")}
          step="1"
          min={0}
        />
      </div>
      <div className="section">
        <label>Making</label>
        <NumInput
          id={`${kp}MakingInput`}
          value={form.making}
          onChange={set("making")}
          step="1"
        />
        <label>Diff</label>
        <NumInput
          id={`${kp}DiffInput`}
          value={form.diff}
          onChange={set("diff")}
        />
        <label>Total Making</label>
        <NumInput
          id={`${kp}MakingTotalInput`}
          value={form.makingTotal}
          readOnly
        />
      </div>
      <div className="section">
        <label>Total Weight</label>
        <NumInput
          id={`${kp}TotalWeightInput`}
          value={form.totalWeight}
          step="0.001"
          readOnly
        />
        <label>Total Amount</label>
        <NumInput
          id={`${kp}TotalAmountInput`}
          value={form.totalAmount}
          readOnly
        />
      </div>
      <div className="section">
        <label>Discount</label>
        <NumInput
          id={`${kp}DiscountInput`}
          value={form.discount}
          onChange={set("discount")}
        />
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <button
          onClick={() => onSave(form)}
          style={{
            flex: 1,
            padding: "8px 16px",
            background: "linear-gradient(135deg,#ffb703 0%,#a87506 100%)",
            color: "#1a0a00",
            border: "none",
            borderRadius: 5,
            fontSize: 14,
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {isEdit ? "Update" : "Save Transaction"}
        </button>
        {!isEdit && onCancel && (
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              background: "#575656",
              color: "#fff",
              border: "1px solid #777",
              borderRadius: 5,
              fontSize: 14,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </>
  );
}

export function CoinForm({
  tx,
  isEdit,
  onSave,
  onCancel,
  isGiven,
  brands,
  refreshBrands,
}) {
  const [form, setForm] = useState({ ...tx });
  const [loadingBrand, setLoadingBrand] = useState(false);
  const [coinWeights, setCoinWeights] = useState([]);
  const { brands: storedBrands } = useBrands();

  const kp = isGiven ? "givenBar" : "receiveBar";
  const set = (key) => (val) =>
    setForm((p) => recalcCoin({ ...p, [key]: val }, isGiven));

  const handleBrandChange = (val) => {
    if (val === "add-new") setForm((p) => ({ ...p, showNewBrand: true }));
    else setForm((p) => ({ ...p, brand: val, showNewBrand: false }));
  };

  const cancelBrand = () =>
    setForm((p) => ({ ...p, showNewBrand: false, newBrandInput: "" }));

  useEffect(() => {
    if (!form.brand || form.brand?.toLowerCase() === "select") {
      setCoinWeights([]);
      return;
    }

    if (!storedBrands || !Array.isArray(storedBrands)) {
      return;
    }

    const barSection = storedBrands.find(
      (brand) => brand.section?.toLowerCase() === "coin",
    );

    const barBrands = barSection?.brands;

    if (!Array.isArray(barBrands)) {
      setCoinWeights([]);
      return;
    }

    const brandData = barBrands.find(
      (brand) => brand.name?.toLowerCase() === form.brand.toLowerCase(),
    );

    if (!brandData) {
      setCoinWeights([]);
      return;
    }

    setCoinWeights(Array.isArray(brandData.weights) ? brandData.weights : []);
  }, [form.brand, storedBrands]);

  useEffect(() => {
    if (!form.brand || !form.weight) {
      setForm((prev) =>
        recalcCoin(
          {
            ...prev,
            making: "",
            _makingModified: false,
          },
          isGiven,
        ),
      );
      return;
    }

    const selectedWeight = coinWeights.find(
      (item) => Number(item.weight) === Number(form.weight),
    );

    // Weight is not configured for this brand
    if (!selectedWeight) {
      setForm((prev) =>
        recalcCoin(
          {
            ...prev,
            making: "",
            _makingModified: false,
          },
          isGiven,
        ),
      );
      return;
    }

    // Weight exists, but making may not be configured
    const making =
      selectedWeight.making !== undefined && selectedWeight.making !== null
        ? selectedWeight.making
        : "";

    setForm((prev) =>
      recalcCoin(
        {
          ...prev,
          making,
          _makingModified: false,
        },
        isGiven,
      ),
    );
  }, [form.weight, coinWeights]);

  return (
    <>
      {isEdit && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 6,
          }}
        >
          <span style={{ fontSize: 12, fontWeight: 700, color: "#ffb703" }}>
            Editing transaction
          </span>
          <button
            onClick={onCancel}
            style={{
              fontSize: 11,
              padding: "3px 10px",
              background: "#575656",
              border: "1px solid #ffb703",
              borderRadius: 4,
              cursor: "pointer",
              color: "#ffb703",
            }}
          >
            Cancel
          </button>
        </div>
      )}

      <div className="section">
        <label>Coin Brand</label>
        {!form.showNewBrand && (
          <select
            className="Brand-selt"
            id={isGiven ? "brandSelt" : "brandSelect"}
            value={form.brand}
            onChange={(e) => handleBrandChange(e.target.value)}
          >
            <option value="Select">Select</option>
            {brands.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
            <option value="add-new">+ Add New Brand</option>
          </select>
        )}

        {form.showNewBrand && (
          <div
            id={isGiven ? "newBrandSeltInput" : "newBrandInput"}
            style={{ display: "block", marginTop: 10 }}
          >
            <input
              type="text"
              id={isGiven ? "brandNameSeltInput" : "brandNameInput"}
              value={form.newBrandInput}
              placeholder="Enter new brand"
              onChange={(e) =>
                setForm((p) => ({ ...p, newBrandInput: e.target.value }))
              }
              style={{
                padding: "8px 12px",
                gap: 5,
                width: "100%",
                border: "2px solid #ddd",
                borderRadius: 6,
                fontSize: 14,
                outline: "none",
                transition: "border-color 0.3s",
                marginBottom: 8,
                boxSizing: "border-box",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#667eea")}
              onBlur={(e) => (e.target.style.borderColor = "#ddd")}
            />
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() =>
                  addBrand(
                    setLoadingBrand,
                    form,
                    setForm,
                    refreshBrands,
                    "coin",
                  )
                }
                style={{
                  padding: "8px 16px",
                  flex: 1,
                  background: "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
                  color: "white",
                  border: "none",
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                disabled={loadingBrand}
              >
                {loadingBrand ? "Loading..." : "Add"}
              </button>
              <button
                onClick={cancelBrand}
                style={{
                  padding: "8px 16px",
                  flex: 1,
                  background: "#f1f3f5",
                  color: "#495057",
                  border: "2px solid #dee2e6",
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        <label>Coin Weight</label>
        <NumInput
          id={`${kp}WeightInput`}
          value={form.weight}
          onChange={set("weight")}
          step="0.001"
          list={`${kp}WeightOptions`}
        />

        <datalist id={`${kp}WeightOptions`}>
          {coinWeights.map((item, index) => (
            <option key={`${item.weight}-${index}`} value={item.weight} />
          ))}
        </datalist>
        <label>Qnty</label>
        <NumInput
          id={`${kp}QtyInput`}
          value={form.qty}
          onChange={set("qty")}
          step="1"
          min={0}
        />
      </div>
      <div className="section">
        <label>Making</label>
        <NumInput
          id={`${kp}MakingInput`}
          value={form.making}
          onChange={set("making")}
          step="1"
        />
        <label>Diff</label>
        <NumInput
          id={`${kp}DiffInput`}
          value={form.diff}
          onChange={set("diff")}
        />
        <label>Total Amount</label>
        <NumInput
          id={`${kp}TotalAmountInput`}
          value={form.totalAmount}
          readOnly
        />
      </div>
      <div className="section">
        <label>Total Weight</label>
        <NumInput
          id={`${kp}TotalWeightInput`}
          value={form.totalWeight}
          step="0.001"
          readOnly
        />
        <label>Karat</label>
        <select
          id={`${kp}KaratSelect`}
          value={form.karat}
          onChange={(e) => set("karat")(e.target.value)}
        >
          <option value="">Select</option>
          <option value="24">24</option>
          <option value="12">12</option>
          <option value="8">8</option>
        </select>
        <label>Pure Weight</label>
        <NumInput
          id={`${kp}PureWeightInput`}
          value={form.pureWeight}
          step="0.001"
          readOnly
        />
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <button
          onClick={() => onSave(form)}
          style={{
            flex: 1,
            padding: "8px 16px",
            background: "linear-gradient(135deg,#ffb703 0%,#a87506 100%)",
            color: "#1a0a00",
            border: "none",
            borderRadius: 5,
            fontSize: 14,
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {isEdit ? "Update" : "Save Transaction"}
        </button>
        {!isEdit && onCancel && (
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              background: "#575656",
              color: "#fff",
              border: "1px solid #777",
              borderRadius: 5,
              fontSize: 14,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </>
  );
}

export function GinniForm({
  tx,
  prefix = "ginni",
  isEdit,
  onSave,
  onCancel,
  isGiven,
  handleReportSubmit,
}) {
  const [form, setForm] = useState({ ...tx });

  useEffect(() => {
    setForm(tx);
  }, [tx]);

  const kp = isGiven ? "givenLab" : "receiveLab";

  const set = (key) => (val) =>
    setForm((p) =>
      recalcGinni({
        ...p,
        [key]: val,
        ...(key === "refineAmount" && { isRefineAmountManual: true }),
      }),
    );

  const handleBrandChange = (val) => {
    if (val === "add-new") setForm((p) => ({ ...p, showNewBrand: true }));
    else setForm((p) => ({ ...p, brand: val, showNewBrand: false }));
  };

  const cancelBrand = () =>
    setForm((p) => ({ ...p, showNewBrand: false, newBrandInput: "" }));

  return (
    <>
      <div className="section">
        <label>Ginni Weight</label>
        <NumInput
          id={`${kp}WeightInput`}
          value={form.weight}
          onChange={set("weight")}
          step="0.001"
        />
        <label>Refine Amount</label>
        <NumInput
          id={`${prefix}RefineAmountInput`}
          value={form.refineAmount}
          onChange={set("refineAmount")}
        />
        <label>Refine Charges</label>
        <NumInput
          id={`${prefix}RefineChargesInput`}
          value={form.refineCharges}
          onChange={set("refineCharges")}
        />
      </div>

      <div className="section">
        <label>Report</label>
        <NumInput
          id={`${kp}ReportInput`}
          value={form.report}
          onChange={set("report")}
        />
        <label>Pure Weight</label>
        <NumInput
          id={`${kp}PureWeightInput`}
          value={form.pureWeight}
          step="0.001"
          readOnly
        />
        <label>Total Amount</label>
        <NumInput
          id={`${kp}TotalAmountInput`}
          value={form.totalAmount}
          readOnly
        />
      </div>

      <div className="section">
        <label>Total Weight</label>
        <NumInput
          id={`${kp}TotalWeightInput`}
          value={form.totalWeight}
          step="0.001"
          readOnly
        />
      </div>

      {handleReportSubmit && (
        <div className="section">
          <button
            type="button"
            className="btn btn-warning px-3"
            onClick={() => handleReportSubmit(form)}
          >
            View Report
          </button>
        </div>
      )}
      <div
        className="d-flex align-items-center gap-2 mb-3"
        style={{
          marginTop: -6,
          cursor: "pointer",
        }}
      >
        <input
          className="form-check-input m-0"
          style={{
            cursor: "pointer",
            width: 15,
            height: 15,
          }}
          type="checkbox"
          id={`${kp}ResendReportGinni`}
          checked={!!form.resendReport}
          onChange={(e) =>
            setForm((p) => ({
              ...p,
              resendReport: e.target.checked,
            }))
          }
        />

        <label
          className="fs-6 m-0"
          htmlFor={`${kp}ResendReport`}
          style={{
            cursor: "pointer",
            userSelect: "none",
            lineHeight: 1,
          }}
        >
          Send Ginni Report via WhatsApp
        </label>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <button
          onClick={() => onSave(form)}
          style={{
            flex: 1,
            padding: "8px 16px",
            background: "linear-gradient(135deg,#ffb703 0%,#a87506 100%)",
            color: "#1a0a00",
            border: "none",
            borderRadius: 5,
            fontSize: 14,
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {isEdit ? "Update" : "Save Transaction"}
        </button>
        {!isEdit && onCancel && (
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              background: "#575656",
              color: "#fff",
              border: "1px solid #777",
              borderRadius: 5,
              fontSize: 14,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </>
  );
}

export function SilverForm({
  tx,
  isEdit,
  onSave,
  onCancel,
  isGiven,
  brands,
  refreshBrands,
}) {
  const [loadingBrand, setLoadingBrand] = useState(false);
  const [form, setForm] = useState({ ...tx });

  const kp = isGiven ? "givenLab" : "receiveLab";
  const set = (key) => (val) =>
    setForm((p) => recalcSilver({ ...p, [key]: val }));

  const handleBrandChange = (val) => {
    if (val === "add-new") setForm((p) => ({ ...p, showNewBrand: true }));
    else setForm((p) => ({ ...p, brand: val, showNewBrand: false }));
  };

  const cancelBrand = () =>
    setForm((p) => ({ ...p, showNewBrand: false, newBrandInput: "" }));

  return (
    <>
      <div className="section">
        <label>Bar Brand</label>
        {!form.showNewBrand && (
          <select
            className="Brand-selt"
            // id={isGiven ? "brandSelt" : "brandSelect"}
            value={form.brand}
            onChange={(e) => handleBrandChange(e.target.value)}
          >
            <option value="Select">Select</option>
            {brands.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
            <option value="add-new">+ Add New Brand</option>
          </select>
        )}

        {form.showNewBrand && (
          <div
            // id={isGiven ? "newBrandSeltInput" : "newBrandInput"}
            style={{ display: "block", marginTop: 10 }}
          >
            <input
              type="text"
              // id={isGiven ? "brandNameSeltInput" : "brandNameInput"}
              value={form.newBrandInput}
              placeholder="Enter new brand"
              onChange={(e) =>
                setForm((p) => ({ ...p, newBrandInput: e.target.value }))
              }
              style={{
                padding: "8px 12px",
                gap: 5,
                width: "100%",
                border: "2px solid #ddd",
                borderRadius: 6,
                fontSize: 14,
                outline: "none",
                transition: "border-color 0.3s",
                marginBottom: 8,
                boxSizing: "border-box",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#667eea")}
              onBlur={(e) => (e.target.style.borderColor = "#ddd")}
            />
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() =>
                  addBrand(
                    setLoadingBrand,
                    form,
                    setForm,
                    refreshBrands,
                    "silver",
                  )
                }
                style={{
                  padding: "8px 16px",
                  flex: 1,
                  background: "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
                  color: "white",
                  border: "none",
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                disabled={loadingBrand}
              >
                {loadingBrand ? "Loading..." : "Add"}
              </button>
              <button
                onClick={cancelBrand}
                style={{
                  padding: "8px 16px",
                  flex: 1,
                  background: "#f1f3f5",
                  color: "#495057",
                  border: "2px solid #dee2e6",
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        <label>Bar Weight</label>
        <input
          type="text"
          id={`${kp}WeightSelect`}
          inputMode="decimal"
          placeholder="Enter weight"
          value={form.barWeight}
          onChange={(e) => set("barWeight")(e.target.value)}
          onWheel={(e) => e.target.blur()}
          list="silverBarWeightOptions"
        />
        <label>Rawal Rod</label>
        <input
          type="text"
          id={`${kp}RawalInput`}
          inputMode="decimal"
          placeholder="Enter rawal weight"
          value={form.rawal}
          onChange={(e) => set("rawal")(e.target.value)}
          onWheel={(e) => e.target.blur()}
          list="silverBarWeightOptions"
        />
      </div>
      <div className="section">
        <label>Qnty</label>
        <NumInput
          id={`${kp}QtyInput`}
          value={form.qty}
          onChange={set("qty")}
          step="1"
          min={0}
        />
        <label>Making (per unit)</label>
        <NumInput
          id={`${kp}MakingInput`}
          value={form.making}
          onChange={set("making")}
        />
        <label>Total Weight</label>
        <NumInput
          id={`${kp}TotalWeightInput`}
          value={form.totalWeight}
          step="0.001"
          readOnly
        />
      </div>
      <div className="section">
        <label>Total Amount</label>
        <NumInput
          id={`${kp}TotalAmountInput`}
          value={form.totalAmount}
          readOnly
        />
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        <button
          onClick={() => onSave(form)}
          style={{
            flex: 1,
            padding: "8px 16px",
            background: "linear-gradient(135deg,#ffb703 0%,#a87506 100%)",
            color: "#1a0a00",
            border: "none",
            borderRadius: 5,
            fontSize: 14,
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {isEdit ? "Update" : "Save Transaction"}
        </button>
        {!isEdit && onCancel && (
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              background: "#575656",
              color: "#fff",
              border: "1px solid #777",
              borderRadius: 5,
              fontSize: 14,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </>
  );
}
